import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../Styles/TopDeals.css";
import { FaFacebookF, FaInstagram, FaYoutube, FaHeadphones } from "react-icons/fa";
import "../Styles/payment.css"

const AboutUs = ({ user }) => (
  <div className="container py-5">
                        <h1 className="elementor-heading-title elementor-size-default">About us</h1>
    <div className="entry-content">
      <div data-elementor-type="wp-page" data-elementor-id="5379" className="elementor elementor-5379">
        <section
          className="elementor-section"
          data-id="638f1de"
          data-element_type="section"
          data-settings='{"stretch_section":"section-stretched","background_background":"classic"}'
          style={{ width: "1720px", left: "-160px", position: "relative" }}
        >
          <div className="elementor-background-overlay"></div>
          <div className="elementor-container elementor-column-gap-default">
            <div className="elementor-column elementor-col-100 elementor-top-column elementor-element" data-id="59d7ddd4">
              <div className="elementor-widget-wrap elementor-element-populated">
                <div className="elementor-widget elementor-widget-heading">
                </div>
                <div className="elementor-widget elementor-widget-divider">
                  <div className="elementor-widget-container">
                    <div className="elementor-divider">
                      <span className="elementor-divider-separator"></span>
                    </div>
                  </div>
                </div>

                {/* Inner Section 1 */}
                <section className="elementor-section elementor-inner-section elementor-section-boxed">
                  <div className="elementor-container elementor-column-gap-default">
                    <div className="elementor-column elementor-col-50 elementor-inner-column">
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-widget elementor-widget-image">
                          <div className="elementor-widget-container">
                            <img
                              src="https://matifoods.in/wp-content/uploads/2023/06/6351144294_c5175ff61c.jpg"
                              width="500"
                              height="500"
                              alt="Ecological resilience"
                              className="elementor-animation-hang attachment-large size-large"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="elementor-column elementor-col-50 elementor-inner-column">
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-widget elementor-widget-heading">
                          <div className="elementor-widget-container">
                            <h3 className="elementor-heading-title elementor-size-default">Our Story</h3>
                          </div>
                        </div>
                        <div className="elementor-widget elementor-widget-text-editor">
                          <div className="elementor-widget-container">
                            <p>
                              Organic agriculture is in its second infancy and the farmers doing so have little access
                              to the right inputs and information. They have to search through various sources, both
                              offline and online, to get the complete set of ingredients required for such novel
                              farming techniques.
                            </p>
                            <p>
                              Mati Foods LLP was started by a group of organic farmers with over 50 years of cumulative
                              agricultural experience. With farms in Delhi and Hyderabad, we have been involved at
                              various points of the organic food value chain. MatiHaat.com is the result of our
                              accumulated knowledge.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                {/* Inner Section 2 */}
                <section className="elementor-section elementor-inner-section elementor-reverse-mobile elementor-section-boxed">
                  <div className="elementor-container elementor-column-gap-default">
                    <div className="elementor-column elementor-col-50 elementor-inner-column">
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-widget elementor-widget-heading">
                          <div className="elementor-widget-container">
                            <h2 className="elementor-heading-title elementor-size-default">Our Mission</h2>
                          </div>
                        </div>
                        <div className="elementor-widget elementor-widget-text-editor">
                          <div className="elementor-widget-container">
                            <p>
                              Our aim is to be a single source for organic farming – knowledge, inputs, and outputs –
                              and to bring the best of the world to our patrons.
                            </p>
                            <p>
                              We are looking to merge traditional knowledge with modern science to develop a perfect
                              portfolio of products.
                            </p>
                          </div>
                        </div>
                        <div className="elementor-widget elementor-widget-text-editor">
                          <div className="elementor-widget-container">
                            <p><strong>The Mati Haat experience:</strong></p>
                            <p>
                              The ultimate goal of Mati Foods is to remove the myth that organic farming and its
                              produce are expensive. Mati Haat aims to make organic agriculture accessible, affordable,
                              and sustainable for the common farmer.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="elementor-column elementor-col-50 elementor-inner-column">
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-widget elementor-widget-image">
                          <div className="elementor-widget-container">
                            <img
                              src="https://matifoods.in/wp-content/uploads/2023/06/190542467_0ab6f6417a_b.jpg"
                              width="1024"
                              height="681"
                              alt="Best Things About Us"
                              className="elementor-animation-hang attachment-large size-large"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
      <footer style={{ backgroundColor: "#f9f9f9", color: "#2b2b2b", padding: "40px 0" }}>
      <Container>
        <Row className="text-center text-md-start">
          {/* Left Column */}
          <Col md={4} className="mb-4 mb-md-0">
            <img
              src="https://matifoods.in/wp-content/uploads/2022/04/Mati-Haat-Web-Logo-2.png"
              alt="Mati Haat"
              style={{ width: "130px", marginBottom: "20px" }}
            />
            <div className="d-flex align-items-center justify-content-center justify-content-md-start">
              <FaHeadphones style={{ color: "#8BC34A", fontSize: "30px", marginRight: "10px" }} />
              <div>
                <p className="mb-0">Got Questions? Call us 24/7!</p>
                <strong>+91 9654870373</strong>
              </div>
            </div>
            <div className="mt-4 d-flex justify-content-center justify-content-md-start gap-3">
              <a href="https://www.facebook.com/profile.php?id=61550736893804" style={{ color: "#000" }} className=" fs-5" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
              <a href="https://www.instagram.com/matihaat/" style={{ color: "#000" }} className="fs-5" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://www.youtube.com/@FarmingwithMatihaat" style={{ color: "#000" }} className="fs-5" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
            </div>
          </Col>

          {/* Middle Column - Quick Links */}
          <Col md={4} className="mb-4 mb-md-0">
            <h5 style={{ color: "#7BA127" }}>Quick Links</h5>
            <ul className="list-unstyled">
              <ul className="list-unstyled">
                <li><a href="/about-us" style={{ color: "#000" }} className="text-decoration-none">About Us</a></li>
                <li><a href="/contact-us" style={{ color: "#000" }} className="text-decoration-none">Reach Us</a></li>
               
                
                
                <li><a href="/track-order" style={{ color: "#000" }} className="text-decoration-none">Track your Order</a></li>
              </ul>
            </ul>
          </Col>

          {/* Right Column - Customer Care */}
          <Col md={4}>
            <h5 style={{ color: "#7BA127" }}>Customer Care</h5>
            <ul className="list-unstyled">
              <li><a href="/privacy-policy" style={{ color: "#000" }} className="text-decoration-none">Privacy Policy</a></li>
              <li><a href="/shipping-policy" style={{ color: "#000" }} className="text-decoration-none">Shipping Policy</a></li>
              <li><a href="/refund-policy" style={{ color: "#000" }} className="text-decoration-none">Refund and Returns Policy</a></li>
              <li><a href="/payment-methods" style={{ color: "#000" }} className="text-decoration-none">Payment Methods</a></li>
              <li><a href="/terms-and-conditions" style={{ color: "#000" }} className="text-decoration-none">Terms and Conditions</a></li>
            </ul>
          </Col>
        </Row>
      </Container>
    </footer>
  </div>
);


export default AboutUs;